import { catchError } from "../catchErrors";
import { getSession } from "../helpers";
import { FRONT_OFFICE_URL } from "../settings";
import HttpStatusCode from "./models/http-status-code";
import { JobAlert } from "./models/job-alert";

export async function createOfferAlert(
  countryId: string,
  province: { id: number; description: string },
  cities: Array<{ id: number; description: string }>,
  search: string,
  frequency: number
) {
  try {
    const session = getSession();
    const url = `${FRONT_OFFICE_URL}Offer/CreateOfferAlert`;
    const towns = cities.map((city) => {
      return {
        townId: city.id,
        town: city.description,
      };
    });
    const body: JobAlert = {
      filterId: null,
      country: countryId,
      provinceId: province.id,
      province: province.description,
      towns,
      frequency,
      function: search,
    };

    const result = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${session?.jwToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return result;
  } catch (error) {
    catchError(error);
  }
}

export async function getOfferAlerts(): Promise<Array<JobAlert>> {
  try {
    const session = getSession();
    const url = `${FRONT_OFFICE_URL}Offer/GetOfferAlerts`;

    let offerAlerts: Array<JobAlert> = [];

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${session?.jwToken}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === HttpStatusCode.OK)
      offerAlerts = await response.json();
    return offerAlerts;
  } catch (error) {
    catchError(error);
    return [];
  }
}
